import { filterService } from '@/_services'
import * as types from './types'

const actions = {
  setFacetAttribute ({ commit, rootGetters, getters }, { index, attribute }) {
    const filters = [
      ...rootGetters['numericsFilters/getNumericValuesQuery'],
      ...getters.getRefinementListFilteredValuesQuery(attribute)
    ]
    const rangeFilters = [
      ...rootGetters['rangesFilters/getRangeValuesQuery']
    ]
    commit(types.SET_FACET_INDEX, { index })
    commit(types.SET_FACET_ATTRIBUTE, { attribute })
    commit(types.SET_FACET_IS_LOADING, { flag: true, attribute })
    filterService[index]({ query: '', facet: attribute, filters, rangeFilters })
    .then((values) => {
      commit(types.SET_FACET_IS_OPEN, { flag: true, attribute })
      commit(types.SET_FACET_AVAILABLE_VALUES, { attribute, values })
    })
    .catch((error) => {
      commit(types.SET_FACET_ERROR, { attribute, error })
      console.error(error)
    })
    .finally(() => {
      commit(types.SET_FACET_IS_LOADING, { flag: false, attribute })
    })
  },
  setFacetAttributeFromURL ({ commit, rootGetters, getters }, { attribute, valuesURL }) {
    commit(types.SET_FACET_ATTRIBUTE, { attribute })
    const availableValues = valuesURL.map((value) => {
      return {
        value,
        count: 0
      }
    })
    commit(types.SET_FACET_AVAILABLE_VALUES, {attribute, values: availableValues})
    valuesURL.forEach((value) => {
      commit(types.SET_FACET_SELECTED_VALUE, { attribute, value })
    })
  },
  setFacetAttributeQuery ({ commit, rootGetters, getters }, { query, index, attribute }) {
    const filters = [
      ...rootGetters['numericsFilters/getNumericValuesQuery'],
      ...getters.getRefinementListFilteredValuesQuery(attribute)
    ]
    const rangeFilters = [
      ...rootGetters['rangesFilters/getRangeValuesQuery']
    ]
    commit(types.SET_FACET_IS_LOADING, { flag: true, attribute })
    filterService[index]({ query, facet: attribute, filters, rangeFilters })
    .then((values) => {
      commit(types.SET_FACET_AVAILABLE_VALUES, { attribute, values })
    })
    .catch((error) => {
      commit(types.SET_FACET_ERROR, { attribute, error })
      console.error(error)
    })
    .finally(() => {
      commit(types.SET_FACET_IS_LOADING, { flag: false, attribute })
    })
  },
  selectFacetValue ({ commit }, { attribute, value }) {
    commit(types.SET_FACET_SELECTED_VALUE, { attribute, value })
  },
  removeFacetValue ({ commit }, { attribute, value }) {
    commit(types.REMOVE_FACET_SELECTED_VALUE, { attribute, value })
  },
  removeAllFacetValues ({ commit }, { notClearable }) {
    commit(types.REMOVE_ALL_SELECTED_VALUES, { notClearable })
  },
  setResetState({ commit }) {
    commit(types.SET_RESET_STATE)
  }
}
export default actions
